// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".idm-subheader .logo-link[data-v-78e7e04e] {\n  position: relative;\n}\n.idm-btn.header.header[data-v-78e7e04e] {\n  margin-left: 24px;\n}\n.scene-save[data-v-78e7e04e] {\n  margin-left: 8px;\n}\n.idm-logo[data-v-78e7e04e] {\n  pointer-events: none;\n}", ""]);
// Exports
module.exports = exports;
